import React from "react";
import successCheck from "./../../assets/Images/success-check.svg";
import warningCheck from "./../../assets/Images/warning-conform-icon.svg";

const SuccessPopup = ({type, show, message, onClose }) => {

  return (
    <div className={`modal fade ${show ? "show d-block" : "d-none"} modal--opacity`}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body text-center p-4">
            <h5 className="mt-2 fnt16 fw-500">{message}</h5>
            {type === 'success' && (
            <img src={successCheck} alt="success-check" className="pt-2" />
            )}
            {type === 'warning' && (
            <img src={warningCheck} alt="warning-check" className="pt-2" />
          )}
            <div>
              <button className="btn btn-primary mt-4 px-3" onClick={onClose}>
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessPopup;
